/* Internal layer implementation for the WebGL and Static viewers */
/* Using DOM elements and CSS */

function Sculpteo3DViewerCommonLayer() {
  this.interactive = 0;
  this.children = [];
  this.frame = { x: 0, y: 0, w: 0, h: 0 };
  this.zindex = 0;
  this.border = 0;

  this.old_IE = $.browser.msie && parseInt($.browser.version) <= 8;

  this.$el = $("<div class='Sculpteo3DViewerCommonLayer'/>");
  this.$el.css({
    position: "absolute",
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    border: "0px solid black",
    opacity: 1.0,
    cursor: "default",
    overflow: "hidden",
  });

  if (this.old_IE) {
    this.$background = $("<div class='Sculpteo3DViewerCommonLayer' />")
      .css({
        width: "100%",
        height: "100%",
        backgroundColor: "rgb(0,0,0)",
        filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)",
      })
      .appendTo(this.$el);
  }

  this.$label = $("<div class='Sculpteo3DViewerCommonLayer' />")
    .css({ position: "absolute", float: "left", "white-space": "nowrap" })
    .appendTo(this.$el);
}

Sculpteo3DViewerCommonLayer.prototype.attach = function (child) {
  this.$el.append(child.$el);
};

Sculpteo3DViewerCommonLayer.prototype.detach = function () {
  this.$el.detach();
};

Sculpteo3DViewerCommonLayer.prototype.addClass = function (className) {
  this.$el.addClass(className);
};

Sculpteo3DViewerCommonLayer.prototype.setFrame = function (x, y, w, h) {
  this.frame.x = x;
  this.frame.y = y;
  this.$el.css({ top: y, left: x });

  if (typeof w != "undefined") {
    this.$el.css({ width: w, height: h });
    this.frame.w = w;
    this.frame.h = h;
  }
};

Sculpteo3DViewerCommonLayer.prototype.setOpacity = function (opacity) {
  this.$el.css({ opacity: opacity });
};

Sculpteo3DViewerCommonLayer.prototype.setBorderColor = function (r, g, b, a) {
  if (!this.old_IE) {
    this.$el.css({
      borderColor: "rgba(" + r + "," + g + "," + b + "," + a / 255.0 + ")",
    });
  } else {
    this.$el.css({ borderColor: "rgb(" + r + "," + g + "," + b + ")" });
  }
};

Sculpteo3DViewerCommonLayer.prototype.setBorderRadius = function (radius) {
  this.$el.css({
    borderRadius: radius + "px",
    mozBorderRadius: radius + "px",
    webkitBorderRadius: radius + "px",
    khtmlBorderRadius: radius + "px",
  });
};

Sculpteo3DViewerCommonLayer.prototype.setBorderWidth = function (width) {
  this.border = width;
  this.$el.css({ borderWidth: width + "px" });
};

Sculpteo3DViewerCommonLayer.prototype.setBackgroundColor = function (
  r,
  g,
  b,
  a
) {
  // For IE
  if (this.old_IE) {
    var c =
      "#" +
      (a < 16 ? "0" : "") +
      parseInt(a).toString(16) +
      (r < 16 ? "0" : "") +
      parseInt(r).toString(16) +
      (g < 16 ? "0" : "") +
      parseInt(g).toString(16) +
      (b < 16 ? "0" : "") +
      parseInt(b).toString(16);

    this.$background.css({
      backgroundColor: "rgba(" + r + "," + g + "," + b + ")",
      filter:
        "progid:DXImageTransform.Microsoft.Alpha(Opacity=" +
        (((a * 100) / 255) | 0) +
        ")",
    });
  } else {
    this.$el.css({
      backgroundColor: "rgba(" + r + "," + g + "," + b + "," + a / 255.0 + ")",
    });
  }
};

Sculpteo3DViewerCommonLayer.prototype.setBackgroundImage = function (
  url,
  offx,
  offy
) {
  if (this.old_IE) {
    if (url) {
      this.$background.css({
        backgroundImage: "url(" + url + ")",
        backgroundPosition: offx + "px " + offy + "px",
      });
    } else {
      this.$background.css({
        backgroundImage: "none",
      });
    }
  } else {
    if (url) {
      this.$el.css({
        backgroundImage: "url(" + url + ")",
        backgroundPosition: offx + "px " + offy + "px",
      });
    } else {
      this.$el.css({ backgroundImage: "none" });
    }
  }
};

Sculpteo3DViewerCommonLayer.prototype.setBackgroundText = function (
  font,
  str,
  r,
  g,
  b,
  a,
  offx,
  offy
) {
  this.$label.css({ font: font, left: offx, top: offy }).html(str);

  if (!this.old_IE) {
    this.$label.css({
      color: "rgba(" + r + "," + g + "," + b + "," + a / 255.0 + ")",
    });
  } else {
    this.$label.css({ color: "rgb(" + r + "," + g + "," + b + ")" });
  }
};

Sculpteo3DViewerCommonLayer.prototype.setZIndex = function (zIndex) {
  this.zindex = zIndex;
  this.$el.css("z-index", zIndex);
};
